import type { LocaleRequestInput, ResolvedLocale } from "../types";

import { getDefaultLocaleCode } from "../registry/locale-registry";
import { buildResolvedLocale } from "./build-resolved-locale";
import { resolveLocaleCodeFromHostname } from "./resolve-locale-code-from-hostname";
import { resolveLocaleCodeFromEnv } from "./resolve-locale-from-env";
import { resolveLocaleCodeFromPathPrefix } from "./resolve-locale-from-path-prefix";
import { resolveLocaleCodeFromQuery } from "./resolve-locale-from-query";

function resolveLocale(input: LocaleRequestInput): ResolvedLocale {
  if (input.allowQueryOverride) {
    const fromQuery = resolveLocaleCodeFromQuery(input.searchParams);

    if (fromQuery) {
      return buildResolvedLocale({ code: fromQuery, source: "query" });
    }
  }

  const fromHostname = resolveLocaleCodeFromHostname(input.hostname);
  if (fromHostname) {
    return buildResolvedLocale({ code: fromHostname, source: "hostname" });
  }

  const fromPathPrefix = resolveLocaleCodeFromPathPrefix(input.pathname);
  if (fromPathPrefix) {
    return buildResolvedLocale({ code: fromPathPrefix, source: "path-prefix" });
  }

  const fromEnv = resolveLocaleCodeFromEnv(input.envWebsiteCountry);
  if (fromEnv) {
    return buildResolvedLocale({ code: fromEnv, source: "env" });
  }

  const defaultCode = getDefaultLocaleCode();

  return buildResolvedLocale({ code: defaultCode, source: "default" });
}

export { resolveLocale };
